import React from "react";
import {Outlet} from "react-router-dom";
import {AppLayout} from "../AppLayout";
import {BaseFilterPanel} from "../panels/BaseFilterPanel";
import {useRouterParamsStoreSync} from "../../store/routerStore";
import {useCompanyIdPersist} from "../../hooks/companyIdPersistHooks";
import {useCompany} from "../../hooks/companiesHooks";

export const InsightsPage: React.FC = () => {
    useCompany();
    useRouterParamsStoreSync();
    useCompanyIdPersist();

    return (
        <AppLayout sidePanel={<BaseFilterPanel basePath="insights" />}>
            <Outlet />
        </AppLayout>
    );
};
